// All REGEX
export default {
  textOnly: "^[a-zA-Z ]*$",
  beginWithText: "^[a-zA-Z]",
  finessNumber: "([0-9]{3} {0,1}){3}",
  cipNumber: "^(([0-9]){7})$",
  timeRange: "^([0-2][0-9]:[0-5][0-9]-[0-2][0-9]:[0-5][0-9]( ){0,1}){1,2}$",
  siret: "([0-9]{3} {0,1}){3}[0-9]{5}",
  frZipCode: "^(0000[1-9]|000[1-9][0-9]|00[1-9][0-9]{2}|0[1-9][0-9]{3}|[1-9][0-9]{4})$",
  frPhoneNumber: "^(0|\\+33|0033)[1-9]([0-9]){8}$",
  frFixPhoneNumber: "^(0|\\+33|0033)[1234589]([0-9]){8}$",
  frMobilePhoneNumber: "^(0|\\+33|0033)[6-7]([0-9]){8}$",
  email: "^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$",
  iban: "^[a-zA-Z]{2}[0-9]{2}[a-zA-Z0-9]{4}[0-9]{7}([a-zA-Z0-9]?){0,16}$",
  bic: "^([A-Z]{6}[A-Z2-9][A-NP-Z1-2])(X{3}|[A-WY-Z0-9][A-Z0-9]{2})?$",
}


// WEBPACK FOOTER //
// ./src/components/Validation/RegexValidator.js